import React, { useEffect, useState } from 'react';
import './AnnounceBar.css';

const MESSAGES = [
  'Order food, groceries, cargo and more, all in the BikesDrop app.',
  'Riders: go online and start earning with BikesDrop today.',
  'Merchants: list your store on BikesFood or BikesGroceries in minutes.',
  'BikesDrop is open for investment and partnership. Talk to our team.',
];

export default function AnnounceBar() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % MESSAGES.length);
    }, 4200);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="announce">
      <div className="container announce__inner">
        <div className="announce__track">
          {MESSAGES.map((msg, i) => (
            <span key={msg} className={`announce__msg ${i === index ? 'announce__msg--active' : ''}`}>
              {msg}
            </span>
          ))}
        </div>
        <a href="#invest" className="announce__link">
          Learn more
        </a>
      </div>
    </div>
  );
}
